import type { TenantSSOSignInFailure } from "@madhive/mad-hooks";
import { HOSTNAME_TO_FIREBASE_PROJECT } from "lib/constants/config";
import { madSDK } from "lib/sdk";

export const SSO_ERRORS: Record<TenantSSOSignInFailure, string> = {
  DISABLED: "Your account is disabled. Contact your administrator.",
  NOT_PROVISIONED:
    "Your account isn't set up for Madhive. Contact your administrator.",
  POPUP_BLOCKED:
    "Your browser blocked the sign-in window. Allow pop-ups for this site and try again.",
  FAILED: "Single sign-on failed. Try again or contact your administrator."
};

export const SSO_LOOKUP_FAILED =
  "We couldn't look up how your organization signs in. Try again.";

/**
 * The auth domain serving the IdP handler. Firebase Hosting serves /__/auth on
 * every custom domain of the project, so a known host of this project is its
 * own auth domain; that keeps the sign-in first-party. Anything else (local
 * dev, previews) uses the project default.
 */
export const tenantSSOAuthDomain = (
  { hostname, host }: Pick<Location, "hostname" | "host"> = window.location
): string => {
  const hostProject = (HOSTNAME_TO_FIREBASE_PROJECT as Record<string, string>)[
    hostname
  ];
  return hostProject === madSDK.madFire.projectId
    ? host
    : `${madSDK.madFire.projectId}.firebaseapp.com`;
};
